import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
		bookings: {},
		bookingsArray: [],
		services: [],
	}),

	getters: {
		bookings(state) {
			return state.bookingsArray;
		},
		services(state) {
			return state.services;
		},
	},

	actions: {
		setBooking({commit}, booking) {
			commit('setBooking', booking);
		},
		async getCalendarBookings({commit}, {startDate, endDate, status}) {
			const response = await api.getCalendarBookings(startDate, endDate, status);
			const { bookings, services } = response?.data || {};
			if (services?.length) {
				commit('setServices', services);
			}
			if (bookings?.length) {
				commit('setBookings', bookings);
				return bookings.map((b) => b.id);
			}
		},
		async updateLogistic({commit}, {bookingId, orderId, logistic}) {
			const response = await api.updateOrderLogistic(bookingId, orderId, logistic);
			commit('setOrderLogistic', {bookingId, orderId, logistic: response.data});
			return response.data;
		}
	},

	mutations: {
		setBooking(state, b) {
			Vue.set(state.bookings, b.id, {...b});
			Vue.set(state, 'bookingsArray', Object.values(state.bookings));
		},
		setBookings(state, bookings) {
			bookings.forEach((b) => {
				Vue.set(state.bookings, b.id, b);
			});
			Vue.set(state, 'bookingsArray', Object.values(state.bookings));
		},
		setOrderLogistic(state, {bookingId, orderId, logistic}) {
			// Sadly, Bookings are not fully moved to bookings.js 
			const booking = state.bookings[bookingId];
			if (booking && booking.order) {
				Vue.set(booking.order, 'logistic', logistic);
			}
		},
		setServices(state, services) {
			Vue.set(state, 'services', services);
		},
	},
}